import React, {
  createContext,
  PropsWithChildren,
  RefObject,
  useContext,
  useMemo,
} from 'react';

type StudyListLayout = {
  toolbarRef: RefObject<HTMLElement>;
  listRef: RefObject<HTMLElement>;
  subHeaderRef: RefObject<HTMLElement>;
  pageContentRef: RefObject<HTMLElement>;
  // Portal target for the sidebars. A future step could lift sidebar state out
  // of the toolbar so the page renders the sidebar directly, without a portal.
  sidebarPanelRoot?: HTMLElement | null;
};

const StudyListLayoutContext = createContext<StudyListLayout>({
  toolbarRef: { current: null },
  listRef: { current: null },
  subHeaderRef: { current: null },
  pageContentRef: { current: null },
  sidebarPanelRoot: null,
});

export const useStudyListLayout = () => useContext(StudyListLayoutContext);

export const StudyListLayoutProvider = ({
  children,
  toolbarRef,
  listRef,
  subHeaderRef,
  pageContentRef,
  sidebarPanelRoot = null,
}: PropsWithChildren<StudyListLayout>) => {
  const value = useMemo(
    () => ({
      toolbarRef,
      listRef,
      subHeaderRef,
      pageContentRef,
      sidebarPanelRoot,
    }),
    [toolbarRef, listRef, subHeaderRef, pageContentRef, sidebarPanelRoot]
  );

  return (
    <StudyListLayoutContext.Provider value={value}>
      {children}
    </StudyListLayoutContext.Provider>
  );
};
